export const statusList = ['pending', 'ongoing', 'done'] as const
export const statusListWithNoneOption = ['pending', 'ongoing', 'done', 'none'] as const
export const statusListWithCancellationOption = ['pending', 'ongoing', 'done', 'cancelled'] as const
export const statusWithNoneAndCancellation = [
  'pending',
  'ongoing',
  'done',
  'cancelled',
  'none'
] as const

export type StatusWithNone = (typeof statusListWithNoneOption)[number]
export type StatusWithCancellation = (typeof statusListWithCancellationOption)[number]
export type StatusWithNoneAndCancellation = (typeof statusWithNoneAndCancellation)[number]

export type StatusWithNoneAndCancellationAndApproverAndWorkOrderStates =
  | 'none'
  | 'pending'
  | 'ongoing'
  | 'done'
  | 'cancelled'
  | 'approved'
  | 'rejected'
  | 'waitingForApproval'
  | 'workOrderCreated'
  | 'implemented'
  | 'implementedTemporary'
  | 'reverted'

export const statusListApprovalStates = [
  'approved',
  'rejected',
  'waitingForApproval',
  'implemented',
  'implementedTemporary',
  'reverted'
] as const
export const statusListWithApproverStates = [...statusList, ...statusListApprovalStates]
export type StatusListWithApproverStates = (typeof statusListWithApproverStates)[number]

export const eventStatusListWorkOrder = ['workOrderCreated'] as const
export type WorkOrderEventStatus = (typeof eventStatusListWorkOrder)[number]

export type EventStatus<T> = T | WorkOrderEventStatus

export enum EventEditModeEnum {
  SINGLE = 'single',
  SINGLE_IN_SERIES = 'singleInSeries',
  SERIES = 'series'
}

export type EventEditModes = 'single' | 'singleInSeries' | 'series'

export enum PmNotificationStatus {
  Unknown = 'unknown',
  OrderAssigned = 'orderAssigned',
  OutstandingNotification = 'outstandingNotification',
  Deleted = 'deleted',
  InProgress = 'inProgress',
  Completed = 'completed'
}

export enum WorkOrderStatus {
  Unknown = 'unknown',
  Closed = 'closed',
  Released = 'released',
  Completed = 'completed',
  Created = 'created'
}

export const pmNotificationStatusListApprovalStates = Object.values(PmNotificationStatus)
export const workOrderStatusListApprovalStates = Object.values(WorkOrderStatus)
